export class DivisionSubjectDto {
    SubjectId: number;
    SubjectName: string;
    MainTeacher: SubjectTeacherDto;
    SubstituteTeacher: SubjectTeacherDto;

    constructor() {
        this.SubjectId = -1;
        this.SubjectName = '';
        this.MainTeacher = new SubjectTeacherDto();
        this.SubstituteTeacher = new SubjectTeacherDto();
    }
}

export class SubjectTeacherDto {
    Id: string;
    FirstName: string;
    LastName: string;

    constructor() {
        this.Id = '';
        this.FirstName = '';
        this.LastName = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/main/models/divisions/division-subject.ts